import React from "react";
import { Outlet } from "react-router-dom";
import AppHeader from "../components/AppHeader";

const MasterLayout: React.FC = () => {
  return (
    <>
      <AppHeader showLogout={true} />
      <div className={`main-container`}>
        <div id='main-content' className='main-content'>
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default MasterLayout;
